module.exports = __webpack_public_path__ + "static/media/KOTAKBANK_F1.69845d77.txt";